import React from 'react';
import Select from '../generics/select';
import { t } from 'i18next';

interface OptionCategoryProps {
  category: any;
  selectedOptions: string[];
  onOptionChange: (optionId: string, checked: boolean) => void;
  onSelectChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

const OptionCategory: React.FC<OptionCategoryProps> = ({
  category,
  selectedOptions,
  onOptionChange,
  onSelectChange
}) => {
  return (
    <div className="border border-gray-200 dark:border-gray-700 rounded-lg p-3">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2">
          <h5 className="text-sm font-medium">{category.name}</h5>
          {category.isRequired && (
            <span className="text-xs text-red-500">*</span>
          )}
        </div>
        
        {category.description && (
          <div className="text-xs text-gray-500 italic">
            {category.description}
          </div>
        )}
      </div>
      
      {category.isMultipleChoice ? (
        // Options à choix multiples (utilisation de checkboxes simples)
        <div className="space-y-2">
          {category.options && category.options.map((option: any) => (
            <div key={option.id} className="flex items-center space-x-2">
              <input
                type="checkbox"
                id={`option-${option.id}`}
                checked={selectedOptions?.includes(option.id) || false}
                onChange={(e) => onOptionChange(option.id, e.target.checked)}
                className="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary"
              />
              <label 
                htmlFor={`option-${option.id}`}
                className="text-sm flex items-center justify-between w-full"
              >
                <span>{option.name}</span>
                {option.price > 0 && (
                  <span className="text-xs font-medium text-gray-500">+{option.price} €</span>
                )}
              </label>
            </div>
          ))}
        </div>
      ) : (
        // Options à choix unique (select)
        <Select
          id={`option-category-${category.id}`}
          name={`option-category-${category.id}`}
          value={selectedOptions?.[0] || ''}
          placeholder={t('dashboard.selectOption', 'Sélectionner une option') || 'Sélectionner une option'}
          onChange={onSelectChange}
          options={category.options?.map((option: any) => ({
            value: option.id,
            label: option.price > 0 ? `${option.name} (+${option.price} €)` : option.name
          })) || []}
          required={category.isRequired}
        />
      )}
    </div>
  );
};

export default OptionCategory;
